<div class="one" fxLayout="column" [formGroup]="MatterPropertyDetailsForm">
  <div fxFlex="100">
    <strong>Electricity</strong>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
    <mat-label>Connection Status</mat-label>
    <mat-select formControlName="ELECTRICITYCONNECTIONSTATUS">
      <mat-option *ngFor="let propertyTypetatusLookup of connectionType" value="{{propertyTypetatusLookup.LOOKUPGUID}}">
        {{propertyTypetatusLookup.LOOKUPFULLVALUE}}
      </mat-option>
    </mat-select>
  </mat-form-field> -->
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Connection Status</mat-label>
      <input
        type="text"
        matInput
        [matAutocomplete]="autoElectricityStatus"
        [value]="getDisplayValue('ELECTRICITYCONNECTIONSTATUS')"
        (blur)="onBlur($event.target.value, 'ELECTRICITYCONNECTIONSTATUS')"
        (keyup.enter)="onDetectChanges($event, 'ELECTRICITYCONNECTIONSTATUS')"
        (keyup)="onDetectChanges($event, 'ELECTRICITYCONNECTIONSTATUS')"
        (focus)="showAllOptions('ELECTRICITYCONNECTIONSTATUS')"
      />

      <mat-autocomplete
        #autoElectricityStatus="matAutocomplete"
        (optionSelected)="onOptionSelected($event.option.value, 'ELECTRICITYCONNECTIONSTATUS')"
      >
        @for (
          propertyTypetatusLookup of filteredOptions['ELECTRICITYCONNECTIONSTATUS'];
          track propertyTypetatusLookup
        ) {
          <mat-option value="{{ propertyTypetatusLookup.LOOKUPGUID }}">
            {{ propertyTypetatusLookup.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Connection Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'ELECTRICITYCONNECTIONDATE')"
        formControlName="ELECTRICITYCONNECTIONDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'ELECTRICITYCONNECTIONDATE')"
        matInput
        name="ConnectionDate"
        [matDatepicker]="ConnectionDate"
      />
      <mat-datepicker-toggle matSuffix [for]="ConnectionDate"></mat-datepicker-toggle>
      <mat-datepicker #ConnectionDate></mat-datepicker>
    </mat-form-field>
  </div>

  <div fxFlex="100">
    <strong>Gas</strong>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
    <mat-label>Connection Status</mat-label>
    <mat-select formControlName="GASCONNECTIONSTATUS">
      <mat-option *ngFor="let propertyTypetatusLookup of connectionType" value="{{propertyTypetatusLookup.LOOKUPGUID}}">
      {{propertyTypetatusLookup.LOOKUPFULLVALUE}}</mat-option>
    </mat-select>
  </mat-form-field> -->
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Connection Status</mat-label>
      <input
        type="text"
        matInput
        [matAutocomplete]="autoGasStatus"
        [value]="getDisplayValue('GASCONNECTIONSTATUS')"
        (blur)="onBlur($event.target.value, 'GASCONNECTIONSTATUS')"
        (keyup.enter)="onDetectChanges($event, 'GASCONNECTIONSTATUS')"
        (keyup)="onDetectChanges($event, 'GASCONNECTIONSTATUS')"
        (focus)="showAllOptions('GASCONNECTIONSTATUS')"
      />

      <mat-autocomplete
        #autoGasStatus="matAutocomplete"
        (optionSelected)="onOptionSelected($event.option.value, 'GASCONNECTIONSTATUS')"
      >
        @for (
          propertyTypetatusLookup of filteredOptions['GASCONNECTIONSTATUS'];
          track propertyTypetatusLookup
        ) {
          <mat-option value="{{ propertyTypetatusLookup.LOOKUPGUID }}">
            {{ propertyTypetatusLookup.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Connection Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'GASCONNECTIONDATE')"
        formControlName="GASCONNECTIONDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'GASCONNECTIONDATE')"
        matInput
        name="ConnectionDate1"
        [matDatepicker]="ConnectionDate1"
      />
      <mat-datepicker-toggle matSuffix [for]="ConnectionDate1"></mat-datepicker-toggle>
      <mat-datepicker #ConnectionDate1></mat-datepicker>
    </mat-form-field>
  </div>

  <div fxFlex="100">
    <strong>Water</strong>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
    <mat-label>Connection Status</mat-label>
    <mat-select formControlName="WATERCONNECTIONSTATUS">
      <mat-option *ngFor="let propertyTypetatusLookup of connectionType" value="{{propertyTypetatusLookup.LOOKUPGUID}}">
      {{propertyTypetatusLookup.LOOKUPFULLVALUE}}</mat-option>
    </mat-select>
  </mat-form-field> -->
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Connection Status</mat-label>
      <input
        type="text"
        matInput
        [matAutocomplete]="autoWaterStatus"
        [value]="getDisplayValue('WATERCONNECTIONSTATUS')"
        (blur)="onBlur($event.target.value, 'WATERCONNECTIONSTATUS')"
        (keyup.enter)="onDetectChanges($event, 'WATERCONNECTIONSTATUS')"
        (keyup)="onDetectChanges($event, 'WATERCONNECTIONSTATUS')"
        (focus)="showAllOptions('WATERCONNECTIONSTATUS')"
      />

      <mat-autocomplete
        #autoWaterStatus="matAutocomplete"
        (optionSelected)="onOptionSelected($event.option.value, 'WATERCONNECTIONSTATUS')"
      >
        @for (
          propertyTypetatusLookup of filteredOptions['WATERCONNECTIONSTATUS'];
          track propertyTypetatusLookup
        ) {
          <mat-option value="{{ propertyTypetatusLookup.LOOKUPGUID }}">
            {{ propertyTypetatusLookup.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Connection Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'WATERCONNECTIONDATE')"
        formControlName="WATERCONNECTIONDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'WATERCONNECTIONDATE')"
        matInput
        name="ConnectionDate2"
        [matDatepicker]="ConnectionDate2"
      />
      <mat-datepicker-toggle matSuffix [for]="ConnectionDate2"></mat-datepicker-toggle>
      <mat-datepicker #ConnectionDate2></mat-datepicker>
    </mat-form-field>
  </div>

  <div fxFlex="100">
    <strong>Sewerage</strong>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
    <mat-label>Connection Status</mat-label>
    <mat-select formControlName="SEWERAGECONNECTIONSTATUS">
      <mat-option *ngFor="let propertyTypetatusLookup of connectionType" value="{{propertyTypetatusLookup.LOOKUPGUID}}">
      {{propertyTypetatusLookup.LOOKUPFULLVALUE}}</mat-option>
    </mat-select>
  </mat-form-field> -->
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Connection Status</mat-label>
      <input
        type="text"
        matInput
        [matAutocomplete]="autoSewerageStatus"
        [value]="getDisplayValue('SEWERAGECONNECTIONSTATUS')"
        (blur)="onBlur($event.target.value, 'SEWERAGECONNECTIONSTATUS')"
        (keyup.enter)="onDetectChanges($event, 'SEWERAGECONNECTIONSTATUS')"
        (keyup)="onDetectChanges($event, 'SEWERAGECONNECTIONSTATUS')"
        (focus)="showAllOptions('SEWERAGECONNECTIONSTATUS')"
      />

      <mat-autocomplete
        #autoSewerageStatus="matAutocomplete"
        (optionSelected)="onOptionSelected($event.option.value, 'SEWERAGECONNECTIONSTATUS')"
      >
        @for (
          propertyTypetatusLookup of filteredOptions['SEWERAGECONNECTIONSTATUS'];
          track propertyTypetatusLookup
        ) {
          <mat-option value="{{ propertyTypetatusLookup.LOOKUPGUID }}">
            {{ propertyTypetatusLookup.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Connection Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'SEWERAGECONNECTIONDATE')"
        formControlName="SEWERAGECONNECTIONDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'SEWERAGECONNECTIONDATE')"
        matInput
        name="ConnectionDate3"
        [matDatepicker]="ConnectionDate3"
      />
      <mat-datepicker-toggle matSuffix [for]="ConnectionDate3"></mat-datepicker-toggle>
      <mat-datepicker #ConnectionDate3></mat-datepicker>
    </mat-form-field>
  </div>

  <div fxFlex="100">
    <strong>Telephone</strong>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
    <mat-label>Connection Status</mat-label>
    <mat-select formControlName="TELEPHONECONNECTIONSTATUS">
      <mat-option *ngFor="let propertyTypetatusLookup of connectionType" value="{{propertyTypetatusLookup.LOOKUPGUID}}">
      {{propertyTypetatusLookup.LOOKUPFULLVALUE}}</mat-option>
    </mat-select>
  </mat-form-field> -->
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Connection Status</mat-label>
      <input
        type="text"
        matInput
        [matAutocomplete]="autoTelephoneStatus"
        [value]="getDisplayValue('TELEPHONECONNECTIONSTATUS')"
        (blur)="onBlur($event.target.value, 'TELEPHONECONNECTIONSTATUS')"
        (keyup.enter)="onDetectChanges($event, 'TELEPHONECONNECTIONSTATUS')"
        (keyup)="onDetectChanges($event, 'TELEPHONECONNECTIONSTATUS')"
        (focus)="showAllOptions('TELEPHONECONNECTIONSTATUS')"
      />

      <mat-autocomplete
        #autoTelephoneStatus="matAutocomplete"
        (optionSelected)="onOptionSelected($event.option.value, 'TELEPHONECONNECTIONSTATUS')"
      >
        @for (
          propertyTypetatusLookup of filteredOptions['TELEPHONECONNECTIONSTATUS'];
          track propertyTypetatusLookup
        ) {
          <mat-option value="{{ propertyTypetatusLookup.LOOKUPGUID }}">
            {{ propertyTypetatusLookup.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Connection Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'TELEPHONECONNECTIONDATE')"
        formControlName="TELEPHONECONNECTIONDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'TELEPHONECONNECTIONDATE')"
        matInput
        name="ConnectionDate4"
        [matDatepicker]="ConnectionDate4"
      />
      <mat-datepicker-toggle matSuffix [for]="ConnectionDate4"></mat-datepicker-toggle>
      <mat-datepicker #ConnectionDate4></mat-datepicker>
    </mat-form-field>
  </div>

  <div fxFlex="100">
    <strong>Internet</strong>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
    <mat-label>Connection Status</mat-label>
    <mat-select formControlName="INTERNETCONNECTIONSTATUS">
      <mat-option *ngFor="let propertyTypetatusLookup of connectionType" value="{{propertyTypetatusLookup.LOOKUPGUID}}">
      {{propertyTypetatusLookup.LOOKUPFULLVALUE}}</mat-option>
    </mat-select>
  </mat-form-field> -->
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Connection Status</mat-label>
      <input
        type="text"
        matInput
        [matAutocomplete]="autoInternetStatus"
        [value]="getDisplayValue('INTERNETCONNECTIONSTATUS')"
        (blur)="onBlur($event.target.value, 'INTERNETCONNECTIONSTATUS')"
        (keyup.enter)="onDetectChanges($event, 'INTERNETCONNECTIONSTATUS')"
        (keyup)="onDetectChanges($event, 'INTERNETCONNECTIONSTATUS')"
        (focus)="showAllOptions('INTERNETCONNECTIONSTATUS')"
      />

      <mat-autocomplete
        #autoInternetStatus="matAutocomplete"
        (optionSelected)="onOptionSelected($event.option.value, 'INTERNETCONNECTIONSTATUS')"
      >
        @for (
          propertyTypetatusLookup of filteredOptions['INTERNETCONNECTIONSTATUS'];
          track propertyTypetatusLookup
        ) {
          <mat-option value="{{ propertyTypetatusLookup.LOOKUPGUID }}">
            {{ propertyTypetatusLookup.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Connection Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'INTERNETCONNECTIONDATE')"
        formControlName="INTERNETCONNECTIONDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'INTERNETCONNECTIONDATE')"
        matInput
        name="ConnectionDate5"
        [matDatepicker]="ConnectionDate5"
      />
      <mat-datepicker-toggle matSuffix [for]="ConnectionDate5"></mat-datepicker-toggle>
      <mat-datepicker #ConnectionDate5></mat-datepicker>
    </mat-form-field>
  </div>
</div>
